var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 9,
    viewBox: "0 0 22 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9V0H2.84763V1.02632H1.82356V7.97368H2.84763V9H0.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44226 7.26316V2.15132L5.24429 2.5954L4.92548 1.52961L6.98328 0.69079H7.77548V7.26316H6.44226Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07859 5.22039V4.125H11.6291V5.22039H9.07859Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.786 5.27961C16.786 5.60855 16.7216 5.90461 16.5928 6.16776C16.464 6.42434 16.2869 6.64474 16.0615 6.82895C15.836 7.00658 15.572 7.14474 15.2693 7.24342C14.973 7.33553 14.651 7.38158 14.3032 7.38158C14.0133 7.38158 13.7203 7.35197 13.424 7.29276C13.1277 7.24013 12.883 7.17105 12.6898 7.08553L12.8733 6.02961C13.0794 6.10855 13.2984 6.17434 13.5303 6.22697C13.7621 6.27303 13.994 6.29605 14.2259 6.29605C14.5994 6.29605 14.8957 6.21711 15.1147 6.05921C15.3401 5.90132 15.4528 5.66776 15.4528 5.35855C15.4528 5.00987 15.3176 4.76316 15.0471 4.61842C14.783 4.46711 14.432 4.39145 13.994 4.39145H12.9506V0.69079H16.4286V1.79605H14.2742V3.31579H14.4771C14.8055 3.31579 15.1082 3.35855 15.3852 3.44408C15.6686 3.52961 15.9133 3.65461 16.1194 3.81908C16.332 3.98355 16.4962 4.1875 16.6121 4.43092C16.7281 4.67434 16.786 4.95724 16.786 5.27961Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1524 9V7.97368H20.1764V1.02632H19.1524V0H21.5V9H19.1524Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleIcon);
export default __webpack_public_path__ + "static/media/scale-icon.b94f776dc070d0225e3de1c154735b86.svg";
export { ForwardRef as ReactComponent };